/**
 * Reintento del PATCH que guarda el id de un enlace Bold ya creado.
 * No vuelve a llamar al endpoint que genera el link.
 */

export const BOLD_LINK_SAVED_BUT_ORDER_NOT_UPDATED =
  'El enlace se generó, pero no se pudo actualizar en el pedido.'

export function readBoldPatchSaveError(error: unknown, fallback: string): string {
  if (error && typeof error === 'object' && 'response' in error) {
    const data = (error as { response?: { data?: { message?: string; error?: string } } }).response?.data
    const fromApi = data?.message || data?.error
    if (fromApi && String(fromApi).trim()) return String(fromApi).trim()
  }
  if (error instanceof Error && error.message.trim()) return error.message.trim()
  return fallback
}

/**
 * Ejecuta el guardado. Si responde mal o no responde, lo intenta una vez más.
 */
export async function attemptTwice<T extends { ok: boolean }>(
  attempt: () => Promise<T>,
  onBeforeRetry?: () => void
): Promise<T> {
  const first = await attempt()
  if (first.ok) return first
  onBeforeRetry?.()
  return attempt()
}
